import { getGroupAll } from '@lumapps/customer/ducks/selectors';
import { getDefaultInstanceLanguage } from '@lumapps/instance/ducks/selectors';
import { connect } from '@lumapps/redux/react';
import { BackOfficeStore } from '@lumapps/redux/types';

import { NavigationItemModal } from './NavigationItemModal';

export const mapStateToProps = (state: BackOfficeStore) => ({
    feedAll: getGroupAll(state),
    defaultInstanceLanguage: getDefaultInstanceLanguage(state),
});

const Connected = connect(mapStateToProps)(NavigationItemModal);

export { Connected as NavigationItemModal };
